import { render, staticRenderFns } from "./ConfirmVendorRequestModal.vue?vue&type=template&id=a5cc437a&"
import script from "./ConfirmVendorRequestModal.vue?vue&type=script&lang=js&"
export * from "./ConfirmVendorRequestModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports